import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "frame"]

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.getAttribute("href") || event.params.url
    if (!url) return

    this.openedFromAi = false
    this._openUrl(url)
  }

  // AIおすすめカードから開く場合
  openFromAi(event) {
    event.preventDefault()
    const url = event.currentTarget.getAttribute("href") || event.params.url
    if (!url) return

    this.openedFromAi = true
    this._openUrl(url)
  }

  close() {
    this.modalTarget.classList.remove("active")
    this.unlockScroll()
    if (this.boundKeydown) {
      document.removeEventListener("keydown", this.boundKeydown)
    }

    // AIから開いていた場合、AIチャットを復元
    if (this.openedFromAi) {
      this.openedFromAi = false
      const aiChatEl = document.querySelector("[data-controller~='ai-chat']")
      const aiChat = this.application.getControllerForElementAndIdentifier(aiChatEl, "ai-chat")
      if (aiChat) {
        aiChat.restore()
        aiChat.lockScroll()
      }
    }
  }

  _openUrl(url) {
    if (this.hasFrameTarget) {
      this.frameTarget.src = url
    }

    this.modalTarget.classList.add("active")
    const scrollable = this.modalTarget.querySelector(".menu-modal-content")
    if (scrollable) scrollable.scrollTop = 0
    this.lockScroll()
    this.boundKeydown = this.keydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  // iOS Safari対応: overflow:hiddenだけでは背景スクロールが止まらない
  lockScroll() {
    this.savedScrollY = window.scrollY
    document.body.style.position = "fixed"
    document.body.style.top = `-${this.savedScrollY}px`
    document.body.style.left = "0"
    document.body.style.right = "0"
    document.body.style.overflow = "hidden"
  }

  unlockScroll() {
    document.body.style.position = ""
    document.body.style.top = ""
    document.body.style.left = ""
    document.body.style.right = ""
    document.body.style.overflow = ""
    window.scrollTo(0, this.savedScrollY || 0)
  }

  clickOverlay(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
